export const postmanKey = 'scpElementSizes';

export interface Sizes {
  bannerHeight: number;
  topbarHeight: number;
  navigationDrawerMobileHeight: number;
}

export type SizesProps = Partial<Sizes>;

export enum SizeVariables {
  bannerHeight = 'banner-container-height',
  topbarHeight = 'topbar-height',
  headerHeight = 'header-height',
  navigationDrawerMobileHeight = 'navigation-drawer-mobile-height',
  topMargin = 'top-margin',
  bottomMargin = 'bottom-margin',
}

export const ititSizes: Sizes = {
  bannerHeight: 0,
  navigationDrawerMobileHeight: 0,
  topbarHeight: 0,
};

export interface ServiceMargins extends Sizes {
  topMargin: number;
  bottomMargin: number;
  /**@deprecated Добавлено для обратной совместимости, новое поле topMargin = bannerHeight + topbarHeight */
  bannerHeight: number;
  /**@deprecated Добавлено для обратной совместимости, новое поле topMargin = bannerHeight + topbarHeight */
  topbarHeight: number;
  /**@deprecated Добавлено для обратной совместимости, новое поле bottomMargin */
  navigationDrawerMobileHeight: number;
}

export const initMargins: ServiceMargins = {
  ...ititSizes,
  topMargin: 0,
  bottomMargin: 0,
};
